import { render, staticRenderFns } from "./website.vue?vue&type=template&id=65138ff3&scoped=true"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"
import style0 from "./website.vue?vue&type=style&index=0&id=65138ff3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65138ff3",
  null
  
)

export default component.exports